import { useGoogleLogin } from "@react-oauth/google";
import Button from "@/core/components/button/Button";
import { useUnit } from "effector-react";
import { googleLoginRequested, $authStore } from "../store/auth";
import { imageList } from "@/core/utils/imageList";

interface GoogleLoginResponse {
  access_token: string;
  expires_in: number;
}

interface GoogleLoginButtonProps {
  isLoginPage?: boolean;
}

const GoogleLoginButton = ({ isLoginPage }: GoogleLoginButtonProps) => {
  const { loading, error } = useUnit($authStore);
  const googleLogin = useUnit(googleLoginRequested);

  const loginWithGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => {
      googleLogin(codeResponse as GoogleLoginResponse);
    },
    onError: (_error) => {
      // console.log("Login Failed:", error);
    },
  });

  return (
    <div className="social-login">
      <Button
        className="social-btn google-btn"
        variant="secondary"
        size="normal"
        outlined
        onClick={() => loginWithGoogle()}
        loading={loading} // Assuming the Button component has a loading prop
        disabled={loading}
      >
        <span className="social-icon">
          <img src={imageList.googleIcon} alt="google icon" />
        </span>
        {isLoginPage && <span>Sign in with Google</span>}
      </Button>

      {/* {error && <div className="error-toast">{error}</div>} */}
    </div>
  );
};

export default GoogleLoginButton;
